export default __webpack_public_path__ + "e816bef06c64d71c03fcf8d1b0ea558e.png";